import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { InventoryService } from '../../../agatextscreens/inventory/inventory.service';
import { TdDialogService } from '@covalent/core';
import { Piece } from '../../../agatextscreens/inventory/piece';
import { Product } from '../../../agatextscreens/purchasing/products/product';
import { PrintingService } from '../../services/printing.service';
import { ProductService } from '../../../agatextscreens/purchasing/products/product.service';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-credit-details',
  templateUrl: './credit-details.component.html',
  styleUrls: ['./credit-details.component.scss'],
})
export class CreditDetailsComponent implements OnInit {
  details: any;

  constructor() { }

  ngOnInit() {

  }

  getCurrentCreditLimit() {
    if (!this.details.credit_margin || !Array.isArray(this.details.credit_margin)) this.details.credit_margin = [];
    this.details.credit_margin = this.details.credit_margin.sort((a, b) => { return (new Date(a.date) > new Date(b.date)) ? -1 : 1 });

    let credit: number;
    if (this.details.credit_margin.length > 0) {
      credit = this.details.credit_margin[0].margin;
    } else {
      credit = 0;
    }

    return credit;
  }

  getRemainingCredit() {
    return Number.parseFloat(this.getCurrentCreditLimit() + '') - (Number.parseFloat(this.details.invoices_outstanding || '0') + Number.parseFloat(this.details.orders_outstanding || '0'))
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/dialogs/credit-details/credit-details.component.ts